import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_BLOGGER_BASE_URL || "https://www.googleapis.com/blogger/v3",
  headers: {
    "Content-Type": "application/json",
  },
});
export default api;